import { Component, Input, ViewChild } from '@angular/core';
import {
  LoadingController,
  NavController,
  Content,
  ToastController,
} from 'ionic-angular';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { ToolsProvider } from '../../providers/tools/tools';
import { UserProvider } from '../../providers/user/user';
import { EventEmitter as EventEmitter2 } from '../../includes/eventEmitter';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as debug from 'debug';

declare let CmKit: any;

@Component({
  selector: 'comments-and-replies',
  templateUrl: 'comments-and-replies.html',
})
export class CommentsAndRepliesComponent {
  log = debug('app:CommentsAndRepliesComponent');

  newComment = {
    commentInformation: {
      text: '',
    },
    engagementType: 'COMMENT',
  };
  comments: any = [];
  visibleComments: any = [];
  commentPageIndex: number = 0;
  userEngagements: any = {};
  loading = true;

  sortMethods = [
    {
      text: 'Top',
      icon: `<svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.2031 8.29688L9.65625 7.20312C9.41016 6.68359 8.5625 6.68359 8.31641 7.20312L7.76953 8.29688L6.56641 8.46094C6.29297 8.51562 6.04688 8.70703 5.96484 8.98047C5.88281 9.25391 5.9375 9.55469 6.15625 9.74609L7.03125 10.5938L6.8125 11.7969C6.70312 12.4258 7.35938 12.8906 7.90625 12.5898L9 12.0156L10.0664 12.5898C10.5859 12.8633 11.2695 12.4258 11.1602 11.7969L10.9414 10.5938L11.8164 9.74609C12.0352 9.55469 12.0898 9.25391 12.0078 8.98047C11.9258 8.70703 11.6797 8.51562 11.4062 8.46094L10.2031 8.29688ZM10.0117 10.293L10.2578 11.7148L9 11.0312L7.71484 11.7148L7.96094 10.293L6.94922 9.30859L8.34375 9.08984L9 7.80469L9.62891 9.08984L11.0234 9.30859L10.0117 10.293ZM16.4102 0.75H12.1172C11.7891 0.75 11.5156 0.914062 11.3516 1.1875L9 5.125L6.62109 1.1875C6.48438 0.941406 6.12891 0.75 5.85547 0.75H1.5625C1.20703 0.75 0.988281 1.16016 1.17969 1.46094L5.14453 7.09375C4.54297 7.88672 4.1875 8.87109 4.1875 9.9375C4.1875 12.6172 6.32031 14.75 9 14.75C11.6523 14.75 13.8125 12.6172 13.8125 9.9375C13.8125 8.87109 13.4297 7.88672 12.8281 7.09375L16.793 1.46094C16.9844 1.16016 16.7656 0.75 16.4102 0.75ZM2.38281 1.625H5.85547L8.01562 5.23438C7.14062 5.42578 6.375 5.83594 5.74609 6.41016L2.38281 1.625ZM12.9375 9.9375C12.9375 12.125 11.1602 13.875 9 13.875C6.8125 13.875 5.0625 12.125 5.0625 9.9375C5.0625 7.77734 6.8125 6 9 6C11.1602 6 12.9375 7.77734 12.9375 9.9375ZM12.2266 6.41016C11.5977 5.83594 10.832 5.42578 9.95703 5.23438L12.1172 1.625H15.5898L12.2266 6.41016Z" fill="#262626"/></svg>`,
      value: 'score',
    },
    {
      text: 'Hot',
      icon: `<svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M6.65625 1.43359C6.65625 0.777344 5.78125 0.503906 5.42578 1.05078C2.82812 5.09766 6.21875 7.28516 6.21875 8.625C6.21875 9.25391 5.72656 9.71875 5.125 9.71875C4.49609 9.71875 4.03125 9.25391 4.03125 8.625V5.75391C4.03125 5.20703 3.42969 4.90625 2.99219 5.20703C1.57031 6.19141 0.75 7.80469 0.75 9.5C0.75 12.3984 3.10156 14.75 6 14.75C8.87109 14.75 11.25 12.3984 11.25 9.5C11.25 4.85156 6.65625 4.25 6.65625 1.43359ZM6 13.875C3.56641 13.875 1.625 11.9336 1.625 9.5C1.625 8.24219 2.17188 6.84766 3.15625 6V8.625C3.15625 9.71875 4.03125 10.5938 5.125 10.5938C6.19141 10.5938 7.09375 9.71875 7.09375 8.625C7.09375 6.84766 4.03125 5.125 5.83594 1.84375C6.4375 5.125 10.375 5.5625 10.375 9.5C10.375 11.9336 8.40625 13.875 6 13.875Z" fill="#262626"/>
            </svg>`,
      value: 'hot',
    },
    {
      text: 'Most Recent',

      icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
               <rect width="24" height="24" fill="white"/>
               <path d="M12 4.96875C8.25391 4.96875 5.21875 8.00391 5.21875 11.75C5.21875 15.4961 8.25391 18.5312 12 18.5312C15.7461 18.5312 18.7812 15.4961 18.7812 11.75C18.7812 8.00391 15.7461 4.96875 12 4.96875ZM17.9062 11.75C17.9062 15.0039 15.2539 17.6562 12 17.6562C8.74609 17.6562 6.09375 15.0312 6.09375 11.75C6.09375 8.52344 8.71875 5.84375 12 5.84375C15.2266 5.84375 17.9062 8.49609 17.9062 11.75ZM13.832 14.1836C13.9688 14.293 14.1875 14.2383 14.2695 14.1016L14.5156 13.8008C14.625 13.6367 14.5703 13.4453 14.4336 13.3359L12.5195 11.9414V7.92188C12.5195 7.75781 12.3555 7.59375 12.1914 7.59375H11.8086C11.6172 7.59375 11.4805 7.75781 11.4805 7.92188V12.2969C11.4805 12.4062 11.5078 12.4883 11.5898 12.5703L13.832 14.1836Z" fill="#262626"/>
            </svg>`,
      value: 'datesAsc',
    },
    {
      text: 'Least Recent',

      icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.9883 11.5586L17.7969 11.3672C17.6602 11.2305 17.4688 11.2305 17.332 11.3672L12.4648 16.2344V5.95312C12.4648 5.78906 12.3008 5.625 12.1367 5.625H11.8633C11.6719 5.625 11.5352 5.78906 11.5352 5.95312V16.2344L6.64062 11.3672C6.50391 11.2305 6.3125 11.2305 6.17578 11.3672L5.98438 11.5586C5.84766 11.6953 5.84766 11.8867 5.98438 12.0234L11.7539 17.793C11.8906 17.9297 12.082 17.9297 12.2188 17.793L17.9883 12.0234C18.125 11.8867 18.125 11.6953 17.9883 11.5586Z" fill="#262626"/></svg>`,
      value: 'datesDesc',
    },
  ];
  sortMethod: any = this.sortMethods[1];

  @Input()
  addCommentComponent: EventEmitter2;
  @Input()
  blockOpenComment: any = false;
  @Input()
  post: any;

  @Input()
  content: Content;
  @Input()
  scrollToEngagement: any;
  @Input()
  thread: any = false;
  @ViewChild('commentReplies')
  commentReplies;
  scrollComment;
  scrollReply;
  subs: any = [];
  showUnverifiedComments;

  constructor(
    public navCtrl: NavController,
    public crudApi: CrudApiProvider,
    public tools: ToolsProvider,
    public user: UserProvider,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController
  ) {
    this.log('CommentAndRepliesComponent constructed');
  }

  ngOnInit(): void {
    // this.showUnverifiedComments =
    //   this.user.info.settings.showUnverifiedComments;
    this.showUnverifiedComments = true;

    // Add Comment Listener
    this.subs.push(
      this.addCommentComponent.on('addComment', engagement => {
        this.addComment(engagement);
      })
    );

    // blockUserInComments
    // rather than have two event emitters through the parent comment and the replies
    // just doing a tools emit to listen for on the comments and replies to filter both
    // the comment/replies emits
    // this single listener is here
    this.subs.push(
      this.addCommentComponent.on('blockUserInComments', comment => {
        this.removeBlockedUserComments(comment);
      })
    );

    // communityPostScrolling

    const engagements = _.get(this.post, 'userEngagements');
    this.userEngagements = this.tools.userEngagementsOnPost(engagements);
    // useful for like notifications opening straight to it
    this.log('should we scroll?', this.scrollToEngagement);
    let postId = _.get(this.post, '_id');
    if (!postId) {
      return;
    }

    this.crudApi
      .get('/api/engagements', {
        post: postId,
        engagementType: 'COMMENT',
        sortBy: 'created',
      })
      .then(d => {
        this.log('response', d.data);
        let all = _.clone(
            _.filter(d.data, d => {
              return this.user.userShouldSeeContent(d);
            })
          ),
          comments = [],
          replies = [],
          additionalComments = 0;

        // Find all comments without a "parentComment"
        // This means top-level comments (not nested replies)
        comments = _.filter(all, o => {
          if (o._id === this.scrollToEngagement) {
            this.scrollComment = o;
          }
          additionalComments += _.get(o, 'stats.comments', 0);
          return !o.parentComment;
        });

        // Update the stats on comments to be the number we loaded
        // just in case it's not the same and confuses users
        this.post.stats.comments = comments.length + additionalComments;

        // Replies are all comments that have a parentComment set
        replies = _.filter(all, o => {
          // If this reply is the engagement you want to scroll to,
          // we need it displayed up front instead of after thye click
          // "view replies"
          if (o.parentComment && o._id === this.scrollToEngagement) {
            // force it to be shown face up
            _.set(o, 'score.numerator', 100000);
            this.scrollReply = o;
          }
          return o.parentComment && this.user.userShouldSeeContent(o);
        });

        // set comment.replies to an array of all replies for that comment
        let replyGroups = _.groupBy(replies, 'parentComment');
        _.each(comments, c => {
          if (this.scrollReply && c._id === this.scrollReply.parentComment) {
            // okay, now we know the comment that needs to be scrolled to
            this.scrollComment = c;
          }
          c.replies = replyGroups[c._id] || [];

          // NOTE: since this is forcing chronological, it may override
          // the unshift above
          c.replies = _.sortBy(c.replies, [
            d => {
              return new Date(d && d.dates && d.dates.created);
            },
          ]);
        });

        this.log('scroll rules', {
          scrollToEngagement: this.scrollToEngagement,
          scrollComment: this.scrollComment,
          scrollReply: this.scrollReply,
        });

        // Attach "replies to replies" by looking at parentReply
        _.each(replyGroups, g => {
          // check each comment in group
          _.each(g, comment => {
            // get parent id
            let pr = _.get(comment, 'parentReply');
            // if parent id exists, then find the original comment
            if (pr) {
              comment.parentReply = _.find(g, r => {
                return r._id === pr;
              });
              this.log('has parentReply id: ', comment);
            }
          });
        });

        this.comments = comments;

        this.setVisibleComments();
      })
      .catch(e => {
        this.log('error getting engagements', e);
      });
  }

  private setVisibleComments() {
    const NUM_HOT_NEW_COMMENTS = 3;
    const COMMENTS_PER_PAGE = 50;

    let method = this.sortMethod.value;
    let comments = _.cloneDeep(this.comments);

    // We made an update to not render all commends immediately,
    // but we don't do that when it's a "scroll to" comment
    if (this.scrollToEngagement) {
      this.visibleComments = comments;
      this.loading = false;
      return;
    }

    const loader = this.loadingCtrl.create({});
    loader.present();

    this.loading = true;

    if (!this.showUnverifiedComments) {
      comments = _.filter(comments, c => {
        return _.get(c, 'user.states.verifiedStatus') === 'verified';
      });
    }

    if (method === 'datesDesc') {
      comments = _.sortBy(comments, 'dates.created');
    } else if (method === 'datesAsc') {
      comments = _.sortBy(comments, 'dates.created').reverse();
    } else if (method === 'hot') {
      comments = _.sortBy(comments, 'dates.created'); // reverse this?
      let newestComments = [];
      if (comments.length > NUM_HOT_NEW_COMMENTS) {
        newestComments = comments.splice(-1 * NUM_HOT_NEW_COMMENTS);
      }
      comments = _.sortBy(comments, c => {
        return _.get(c, 'score.numerator');
      }).reverse();

      if (newestComments.length) {
        _.each(newestComments, (c, i) => {
          // drop NUM_HOT_NEW_COMMENTS most recent comments in the 2, 4, 5, 6, 8, 10, 12, 14...
          comments.splice(i ? (i === 1 ? 3 : i * 2) : 1, 0, newestComments[i]);
        });
      }
    } else if (method === 'score') {
      comments = _.sortBy(comments, c => {
        return _.get(c, 'score.numerator');
      }).reverse();
    } else {
      this.visibleComments = this.comments;
    }
    this.visibleComments = _.slice(
      comments,
      0,
      (this.commentPageIndex + 1) * COMMENTS_PER_PAGE
    );

    loader.dismiss();
    this.loading = false;
  }

  moreVisibleComments() {
    this.commentPageIndex++;
    this.setVisibleComments();
  }

  async changeSort(setting) {
    const selectedMethod = await CmKit.ActionSheet({
      props: {
        title: 'Sort By',
        buttons: this.sortMethods.map(o => {
          return {
            text: o.text,
            // subText: o.subText,
            icon: o.icon,
            value: o.value,
          };
        }),
      },
    }).promise;

    if (selectedMethod) {
      this.sortMethod = selectedMethod;
      this.setVisibleComments();
    }
  }

  private removeBlockedUserComments(comment) {
    this.log('removing comments BLOCKED USER');
    const commentUserId = _.get(comment, 'user._id');
    const postUserId = _.get(this.post, 'user._id');

    if (commentUserId === postUserId) {
      // if blockUser is post creator, pop back to feed / refresh

      this.navCtrl.pop();
    } else {
      // if blockUser is not post creator, filter both comments and replies
      this.comments = _.filter(this.comments, c => {
        c.replies = _.filter(_.get(c, 'replies'), r => {
          return _.get(r, 'user._id') !== commentUserId;
        });

        this.log('filtering, c.user._id', c.user._id === commentUserId);
        return _.get(c, 'user._id') !== commentUserId;
      });
    }
  }

  ngOnDestroy() {
    _.each(this.subs, s => {
      if (s instanceof Function) {
        s();
      } else if (s.unsubscribe) {
        s.unsubscribe();
      }
    });
  }

  private addComment(e) {
    let engagement = e;

    if (!e) {
      return;
    }
    let c: any = engagement;
    c.user = this.user.get();
    c.userEngagement = this.tools.userEngagementsOnPost(c.userEngagements);
    c.replies = [];
    c.dates = {
      created: moment().toDate(),
    };
    c.stats = c.stats || {
      likes: 0,
      comments: 0,
      reports: 0,
      shares: 0,
    };

    this.tools.logEventAndFlush('comment');
    this.comments.push(c);

    this.setVisibleComments();

    try {
      this.post.stats.comments += 1;
    } catch (e) {
      this.log('counldnt add stats', this.post);
    }

    this.newComment.commentInformation.text = '';

    setTimeout(() => {
      try {
        this.content.scrollTo(0, this.commentReplies.nativeElement.offsetTop);
        this.addCommentComponent.emit('addCommentSuccess');
        this.tools.logAnalyticsEvent('trackCustom', 'comment-engagement', {
          user: _.get(c, 'user._id'),
        });
      } catch (e) {
        this.log('error with scroll to', e);
        this.tools.logAnalyticsEvent(
          'trackCustom',
          'comment-engagement-error',
          {
            user: _.get(c, 'user._id'),
          }
        );
      }
    }, 500);

    // replace user object with _id to avoid payload issues
    const commentPayload = _.cloneDeep(c);
    _.set(commentPayload, 'user', _.get(commentPayload, 'user._id'));

    this.crudApi.post('/api/engagements', commentPayload).then(
      res => {
        this.log('addComment res', res.data);
        _.set(c, '_id', _.get(res.data, '_id'));
        this.log('addComment res merge c', _.cloneDeep(c));
        this.addCommentComponent.emit('updateReplyListener');
        this.addCommentComponent.emit('updateUpdateListener', _.get(c, '_id'));
      },
      e => {
        this.addCommentComponent.emit('addCommentError', c);
        console.error('error: ', c);
        this.post.stats.comments -= 1;
        _.remove(this.comments, c);

        const toast = this.toastCtrl.create({
          message:
            'An error occurred while commenting. Please check your connection and try again. If the issue continues, please contact us for help.',
          position: 'top',
          duration: 5000,
        });
        toast.present();
        this.tools.logAnalyticsEvent(
          'trackCustom',
          'comment-engagement-error',
          {
            user: _.get(c, 'user._id'),
          }
        );
      }
    );
  }

  hideUnverifiedComments() {
    this.showUnverifiedComments = !this.showUnverifiedComments;

    const update = {
      settings: {
        showUnverifiedComments: this.showUnverifiedComments,
      },
    };

    this.user.crudUpdate(update, { hideLoader: true }).catch(e => {
      this.log('ERROR == ', e);
    });

    this.setVisibleComments();
  }
}



// WEBPACK FOOTER //
// ./src/components/comments-and-replies/comments-and-replies.ts